import React from 'react';

import { isObject } from 'apps/auth/helpers/utils';

import OnfidoDoc from './OnfidoDoc';

const OnfidoDocList = (props) => {
    return (
        <ul>
            {isObject(props.acceptableDocuments) &&
                props.acceptableDocuments.map((doc, i) => (
                    <OnfidoDoc
                        key={i}
                        type={doc.type}
                        userType={props.userType}
                        title={doc.title}
                        onClick={props.onClick}
                        subTitle={doc.subTitle}
                        userCountryId={props.userCountryId}
                        flagName={doc.issuedCountry}
                        userCountryInEEA={props.userCountryInEEA}
                    />
                ))}
        </ul>
    );
};
export default OnfidoDocList;
